<template>
    <div v-if="rubric">
        <div class="component-title">
            <h5>{{ rubric.title }}</h5>

            <div class="rubric-options">
                <slot name="options"></slot>
            </div>
        </div>

        <div class="rubric-show-description">
            <design2021-apprentice-display-html-component class="cell-content" :html-content="rubric.description" v-if="rubric.description !== '' ||rubric.description !== null">
            </design2021-apprentice-display-html-component>

            <p v-else>
                {{
                   $t('rubrics.there_is_no_description_for_this_rubric_yet')
                }}
            </p>
        </div>

        <!--            todo deze div moet in rubric-form-section component-->
        <div
            class="rubric-show"
            v-for="(section, index) in rubric.rubric_sections"
            :key="`rubric-section-${section.id}`"
            :class="`errubric-section-${index}`">
            <design-2021-rubric-form-section-component
                :section-in="section"
                :key="section.id"
                :show-other-results="showOtherResults"
                :edit="edit"
                :form-id-in="rubricForm.id"
                :rubric-show-advanced-options="!!rubric.show_values"
                @cell-selected="cellSelected($event)">
            </design-2021-rubric-form-section-component>
        </div>

        <design-2021-rubric-form-feedback-input-component
            :edit="edit"
            @update-feedback="feedbackUpdated($event)"
            :feedback-in="authUserFeedback">
        </design-2021-rubric-form-feedback-input-component>

        <!--            todo maak hiervan slot-->
        <!--            <div class="rubric-submit" v-if="edit">-->
        <!--                <b-button variant="success" class="btn-save" @click="storeRubricAnswers">-->
        <!--&lt;!&ndash;                    <span v-if="!multiple || !multiple.count_left">Opslaan</span>&ndash;&gt;-->
        <!--&lt;!&ndash;                    <span v-else> Opslaan en volgende</span>&ndash;&gt;-->
        <!--                    <span> Opslaan</span>-->
        <!--                </b-button>-->
        <!--            </div>-->

        <design-2021-rubric-form-feedback-peer-component
            v-if="showOtherResults"
            :results-in="peerResults">
        </design-2021-rubric-form-feedback-peer-component>
    </div>
</template>

<script>
import Design2021ApprenticeDisplayHtmlComponent from '../../common/design-2021-apprentice-display-html-component.vue';

export default {
    name: 'design-2021-rubric-form-component',
    components: { Design2021ApprenticeDisplayHtmlComponent },
    props: {
        rubricIn: Object,
        rubricFormIn: Object,
        edit: {
            type: Boolean,
            default: false,
        },
        showOtherResults: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            rubric: this.rubricIn,
            rubricForm: this.rubricFormIn,
            feedback: this.authUserFeedback,
        };
    },
    computed: {
        authUserFeedback() {
            let rubricFormResult = null;
            if (this.rubricForm.rubric_form_results.length) {
                rubricFormResult = this.rubricForm.rubric_form_results.find(
                    (result) => result.user_id === this.$authUser.id,
                );
            }
            return rubricFormResult ? rubricFormResult.feedback : null;
        },
        peerResults() {
            return this.rubricForm.rubric_form_results.filter((result) => {
                return result.user_id !== this.$authUser.id;
            });
        },
    },
    watch: {
        rubricIn() {
            this.rubric = this.rubricIn;
            this.rubricForm = this.rubricFormIn;
            this.feedback = this.authUserFeedback;
        },
    },
    methods: {
        cellSelected(newAnswer) {
            this.rubric.rubric_sections.map((rubricSection) => {
                rubricSection.rubric_rows = rubricSection.rubric_rows.map((rubricRow) => {
                    if (rubricRow.id !== newAnswer.row_id) {
                        return rubricRow;
                    }

                    const currentAnswerForRowAndAuthUser = rubricRow.answers.find((currentAnswer) => {
                        return currentAnswer.row_id === rubricRow.id && currentAnswer.user_id === this.$authUser.id;
                    });

                    if (!currentAnswerForRowAndAuthUser) {
                        rubricRow.answers.push(newAnswer);
                    } else {
                        rubricRow.answers = rubricRow.answers.map((currentAnswer) => {
                            return currentAnswer.id !== currentAnswerForRowAndAuthUser.id
                                ? currentAnswer
                                : { ...currentAnswer, ...newAnswer };
                        });
                    }
                    return rubricRow;
                });
                return rubricSection;
            });
        },
        feedbackUpdated(newFeedback) {
            let result = this.rubricForm.rubric_form_results.find((result) => result.user_id === this.$authUser.id);
            if (result) {
                this.rubricForm.rubric_form_results.map((result) => {
                    if (result.user_id === this.$authUser.id) {
                        result.feedback = newFeedback;
                    }
                    return result;
                });
            } else {
                this.rubricForm.rubric_form_results.push({
                    rubric_form_id: this.rubricForm.id,
                    user_id: this.$authUser.id,
                    feedback: newFeedback,
                });
            }
            this.feedback = newFeedback;
        },
        clear(rubric, rubricForm) {
            this.rubric = rubric;
            this.rubricForm = rubricForm;
            this.feedback = this.authUserFeedback;
        },
        getAnswers() {
            let rubricAnswers = [];
            for (const section of this.rubric.rubric_sections) {
                for (const row of section.rubric_rows) {
                    for (const answer of row.answers) {
                        if (answer.user_id === this.$authUser.id) {
                            rubricAnswers.push(answer);
                            break;
                        }
                    }
                }
            }
            return rubricAnswers;
        },
        getFeedback() {
            return this.authUserFeedback;
        },
    },
};
</script>

<style scoped lang="scss">
.component-title {
    align-items: center;

    h5 {
        margin-bottom: 0;
    }
}

.rubric-answer-show {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.rubric-title {
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.rubric-show-description {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.rubric-show-description p {
    font-size: $default-font-size;
    color: $text-muted-color;
}

.rubric-show-section {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
}

.rubric-show-section + .rubric-show-section {
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
}

.rubric-show-values {
    display: flex;
    overflow-x: auto;
    border-left: 1px solid $border-color;
    border-right: 1px solid $border-color;
    background-color: $secondary-background-color;
    width: calc(100% - 210px);
}

.rubric-show-column {
    width: 210px;
    border-bottom: 1px solid $border-color;
    border-right: 1px solid $border-color;
}

.rubric-feedback {
    margin-top: map-get($grid-gutter-spacing, 'twenty-one') * 2;
}

.rubric-feedback textarea {
    margin-bottom: 0;
}

.rubric-submit {
    display: flex;
    justify-content: center;
    margin-top: map-get($grid-gutter-spacing, 'twenty-one') * 2;

    .btn {
        color: $white;
    }
}

.rubric-multiple-bar {
    margin-bottom: $grid-gutter-width;

    .remaining-form-notice {
        font-size: $base-font-size;
    }

    .forms-count {
        font-weight: $font-weight-bold;
    }

    .next-rubric {
        margin-top: map-get($grid-gutter-spacing, 'twenty-one');

        .btn-next-rubric-form {
            display: flex;
            align-items: center;
            flex-direction: column;
            width: 100%;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .rubric-multiple-bar {
        .next-rubric {
            .btn-next-rubric-form {
                flex-direction: row;
                width: auto;

                .next-form-user {
                    margin-left: map-get($grid-gutter-spacing, 'ten');
                }
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .rubric-show-description {
        max-inline-size: 1170px;
    }
}
</style>
